export default __webpack_public_path__ + "static/media/rede2.65acf461.png";